export default (languageSelect) => {
  if (languageSelect.children.length > 1) {
    const languageTop = languageSelect.querySelector('.language-selection__top');
    const languageItems = languageSelect.querySelector(
      '.language-selection__items',
    );

    const closeItems = () => {
      languageItems.classList.remove('active');
      languageSelect.classList.remove('active');
    };

    if (languageTop) {
      languageTop.addEventListener('click', () => {
        languageItems.classList.toggle('active');
        languageSelect.classList.toggle('active');
      });
    }

    languageSelect.addEventListener('click', (even) => {
      const item = even.target;
      if (item.classList.contains('language-selection__item')) {
        closeItems();
      }
    });

    document.addEventListener('click', (even) => {
      const withinBoundaries = even.composedPath().includes(languageSelect);

      if (!withinBoundaries) {
        closeItems();
      }
    });
  }
};
